import { render, staticRenderFns } from "./ProductChannelPrices.vue?vue&type=template&id=64428f52&scoped=true&"
import script from "./ProductChannelPrices.vue?vue&type=script&lang=js&"
export * from "./ProductChannelPrices.vue?vue&type=script&lang=js&"
import style0 from "./ProductChannelPrices.vue?vue&type=style&index=0&id=64428f52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64428f52",
  null
  
)

export default component.exports